<ng-container *ngIf="data">
	<div class="request-card" [fxLayout]="type === 'horizontal' ? 'row' : 'column'"
		[fxLayoutAlign]="type === 'horizontal' ? 'start center' : 'start stretch'"
		[fxLayoutGap]="type === 'horizontal' ? '10px' : '0px'" [ngClass]="type">
		<ng-container *ngIf="data?.thumbnail || data?.userName">
			<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px" class="thumbnail-block">
				<ng-container *ngIf="data?.thumbnail">
					<div class="thumbnail-dtls" fxLayout="row"
						[fxLayoutAlign]="type === 'horizontal' ? 'start center' : 'center center'" (click)="profileInfo(data)">
						<div [fxFlex]="type === 'horizontal' ? '0 0 64px' : '0 0 44px'"
							[ngStyle]="{ height: type === 'horizontal' ? '64px' : '44px'}">
							<div class="thumbnail cursor-pointer">
								<img class="img" [src]="data?.thumbnail" (error)="gfService.setErrorImage($event, 'man')">
							</div>
						</div>
					</div>
				</ng-container>
				<ng-container *ngIf="type === 'vertical' && data?.userName">
					<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
						<ng-container [ngTemplateOutlet]="userName" [ngTemplateOutletContext]="{data: data}">
						</ng-container>
					</div>
				</ng-container>
			</div>
		</ng-container>

		<ng-container
			*ngIf="data?.userName || data?.title || data?.description || data?.nominatedUserThumbnail || data?.nominatedUserCount || data?.date || data?.actions?.length">
			<div fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="8px" class="card-content-block">
				<div fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="2px">

					<ng-container *ngIf="data?.userName || data?.title || data?.description">
						<div [fxLayout]="type === 'horizontal' ? 'row' : 'column'"
							[fxLayoutAlign]="type === 'horizontal' ? 'start center' : 'center center'" fxLayoutGap="10px"
							class="card-info">
							<ng-container *ngIf="type === 'horizontal'">
								<div [fxFlex]="type === 'horizontal' ? '1 1' : 'auto'" fxLayout="column" fxLayoutAlign="start stretch"
									fxLayoutGap="5px">
									<ng-container *ngIf="data?.userName">
										<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
											<ng-container [ngTemplateOutlet]="userName" [ngTemplateOutletContext]="{data: data}">
											</ng-container>
										</div>
									</ng-container>
									<ng-container *ngIf="data?.title || data?.description">
										<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="2px" class="title-block">
											<ng-container [ngTemplateOutlet]="titleDescription" [ngTemplateOutletContext]="{data: data}">
											</ng-container>
										</div>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</ng-container>

					<!---third row-->
					<ng-container
						*ngIf="data?.nominatedUserThumbnail || data?.nominatedUserName || data?.date || data?.actions?.length">
						<div [fxFlex]="type === 'horizontal' ? '0 0 auto' : '1 1'"
							[fxLayout]="type === 'horizontal' ? 'row wrap' : 'column'"
							[fxLayoutAlign]="type === 'horizontal' ? 'space-between center' : 'space-between stretch'"
							[fxLayoutGap]="type === 'horizontal' ? '5px' : '15px'" class="card-overview-block">
							<ng-container *ngIf="data?.nominatedUserThumbnail || data?.nominatedUserName || data?.date">
								<div fxLayout="row wrap"
									[fxLayoutAlign]="type === 'horizontal' ? 'start center' : 'space-between center'"
									[fxLayoutGap]="type === 'horizontal' ? '15px' : '15px'" class="left-overview">
									<ng-container *ngIf="data?.nominatedUserThumbnail || data?.nominatedUserName">
										<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
											<ng-container *ngIf="data?.nominatedUserThumbnail">
												<div class="user-pic cursor-pointer" fxFlex="0 0 18px" (click)="nominatedUserProfileInfo(data)">
													<img [src]="data?.nominatedUserThumbnail" (error)="gfService.setErrorImage($event,'man')">
												</div>
											</ng-container>
											<ng-container *ngIf="data?.nominatedUserName">
												<span class="sub-caption-1 cursor-pointer"
													(click)="nominatedUserProfileInfo(data)">{{locale.translate('nominated_by')}}
													{{data?.nominatedUserName}}
												</span>
												<ng-container *ngIf="data?.nominatedUserCount">
													<span class="sub-caption-1 cursor-pointer" (click)="nominatedUsersInfo(data)">
														+ {{data?.nominatedUserCount}}
													</span>
												</ng-container>
											</ng-container>
										</div>
									</ng-container>
									<ng-container *ngIf="data?.date">
										<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" class="overview-item date">
											<span>{{data?.date}}</span>
										</div>
									</ng-container>
								</div>
							</ng-container>
							<ng-container *ngIf="type === 'vertical' && (data?.title || data?.description)">
								<div fxLayout="row" fxLayoutAlign="center center">
									<div fxLayout="column" fxLayoutGap="8px" fxLayoutAlign="center center" class="title-block">
										<ng-container [ngTemplateOutlet]="titleDescription" [ngTemplateOutletContext]="{data: data}">
										</ng-container>
									</div>
								</div>
							</ng-container>
							<ng-container *ngIf="data?.actions?.length">
								<div fxLayout="row wrap" [fxLayoutAlign]="type === 'horizontal' ? 'start center' : 'center center'"
									class="right-overview">
									<ng-container [ngTemplateOutlet]="actions" [ngTemplateOutletContext]="{data: data}">
									</ng-container>
								</div>
							</ng-container>
						</div>
					</ng-container>
				</div>
			</div>
		</ng-container>
	</div>
</ng-container>

<ng-template #userName let-data="data">
	<span class="user-title">{{data?.userName}}</span>
</ng-template>

<ng-template #titleDescription let-data="data">
	<ng-container *ngIf="data?.title">
		<div  fxLayoutAlign="start center">
		<p class="card-title linkable" (click)="info(data)">{{data?.title}}</p>
		</div>
	</ng-container>
	<ng-container *ngIf="data?.description">
		<div class="card-description">{{data?.description}}</div>
	</ng-container>
</ng-template>

<ng-template #actions let-data="data">
	<div class="button-block" fxLayout="row" [fxLayoutAlign]="type === 'horizontal' ? 'start center' : 'center center'"
		[fxLayoutGap]="type === 'horizontal' ? '10px' : '5px'">
		<ng-container *ngFor="let action of data?.actions">
			<button mat-button class="sub-action-btn-2" type="button" #actionEl [ngClass]="action?.classes"
				(click)="actionInfo({actionEl: actionEl, action: action})">
				{{action?.caption}}
			</button>
		</ng-container>
	</div>
</ng-template>
